import { create } from 'zustand';

interface OpenCardState {
  activeId: string | null;
  open: (id: string) => void;
  close: () => void;
}

export const useOpenCard = create<OpenCardState>((set) => ({
  activeId: null,
  open: (id) => set({ activeId: id }),
  close: () => set({ activeId: null }),
}));

interface CutSaleState {
  /** The storefront whose sign-in took a card away mid-purchase, this visit. */
  tutorUsername: string | null;
  cut: (tutorUsername: string) => void;
}

// The card that knew why is gone by the time its sign-in resolves; this is how
// the intro card that replaced it gets to say so.
export const useCutSale = create<CutSaleState>((set) => ({
  tutorUsername: null,
  cut: (tutorUsername) => set({ tutorUsername }),
}));
